import * as yup from "yup";

export const partial_redemption_schema = {
  asset_class: null,
  fund: null,
  class: null,
  redemption: "",
  quantity: "",
  transfer: null,
  accounts: null,
  portfolio: null,
};

export const partial_redemption_validation_schema = yup.object().shape({
  asset_class: yup.object().required("asset_class_required"),
  fund: yup.object().required("fund_required"),
  // class: yup.object().required("class_required"),
  transfer: yup.object().required("transfer_required"),
  redemption: yup
    .string()
    .matches(/^(?:\d+|\d+\.\d*)$/, "redemption_digit_validation"),
  quantity: yup
    .string()
    .matches(/^(?:\d+|\d+\.\d*)$/, "quantity_digit_validation"),
  portfolio: yup.object().required("portfolio_required"),
});

export const redemption_schema = {
  asset_class: null,
  fund: null,
  class: null,
  transfer: null,
  accounts: null,
  portfolio: null,
};

export const redemption_validation_schema = yup.object().shape({
  asset_class: yup.object().required("asset_class_required"),
  fund: yup.object().required("fund_required"),
  // class: yup.object().required("class_required"),
  transfer: yup.object().required("transfer_required"),
  portfolio: yup.object().required("portfolio_required"),
});
